export default {
  group_id: [
    {required: true}
  ],
  code: [
    {required: true},
  ],
  name: [
    {required: true},
  ],
  description: [],
  is_postpaid: [
    {type: 'boolean', required: true}
  ],
  denomination: [],
  price_scheme: [
    { required: true }
  ],
  price: [],
  admin_fee: [],
  share_fee: [],
  profit_threshold: []
}
